import { config } from "@lib/utils/config";

export const log: typeof console.log =
  config.environment === "production"
    ? (..._data: any[]) => { }
    : (...data: any[]) => {
      console.log(new Date().toISOString(), ...data);
    };
